import React, { Component, useState ,useEffect} from 'react';
import { useLocation , useParams , useNavigate} from 'react-router-dom';
import MyPagination from "../Helpers/MyPagination";
import Filter from "./Filter";
import Table from "../Shared/Table";
import Config  from "../Helpers/Config";
import Helpers from "../Helpers/Custom";
import Axios from 'axios';
import Loader from "../../utils/Loader";

function Options(props) {

    const { state } = useLocation();
    //const { type } = useParams()
    const navigate = useNavigate();
    const [payload, setPayload] = useState({});
    const [fromDate, setFromDate] = useState(new Date("01-Jan-1970"));
    const [data, setData] = useState({});
    const [filterData, setFilterData] = useState({})
    const [sortBy, setSortBy] = useState("date");
    const [sortOrder, setSortOrder] = useState("DESC");
    const [toDate, setToDate] = useState(new Date(state?.payload?.asOfDate));
    const [loading, setLoading] = useState(false);

    const [activePage, setActivePage] = useState(0);
    const [totalRecords , setTotalRecords] = useState(0);
    const [type,setType] = useState(Helpers.getParameterByName("type"));
    localStorage.setItem("pageName","Transactions");

    useEffect(() => {
        var lclPayload = state?.payload;
        if(!Helpers.isEmpty(lclPayload)){
             lclPayload.securityIds = Helpers.getParameterByName("id");
             lclPayload.assetClass = type;
        }

        console.log(type,"type")
        setPayload(lclPayload);
        if(!Helpers.isEmpty(payload)){
            fetchFilterData();
            fetchMainData();
        }
        
    }, [payload])

    const handlePageChange = (pageNumber)=>{
        setActivePage(pageNumber-1);
        fetchMainData(pageNumber-1);
    }

    const fetchMainData = (slug,sort)=>{
        setLoading(true)
        var sorting = Helpers.isEmpty(sort) ? sortOrder : sort;

        payload.sortOrder = sorting;
        payload.sortBy = sortBy;
        payload.pageNo = !Helpers.isEmpty(slug) ? slug : 0;
        payload.pageSize = Config.pageSize;
        payload.fromDate = Helpers.getDateInInputFormat(fromDate);
        payload.toDate = Helpers.getDateInInputFormat(toDate);

        Axios.get(Config.api("api/portfolios/trx/public"),{
            params:payload
        })
        .then( (response) => {
            var dataset  = response.data;
            setData(dataset.content);
            setTotalRecords(dataset.totalPages);
            setLoading(false)
        })
        .catch((err) => {
            Helpers.pushError(err.response.data.message)
            setData([])
        });
    }

    const fetchFilterData = ()=>{
        setLoading(true)
       Axios.get(Config.api("api/portfolios/trx-req/"+type),{
        params:payload
        })
        .then( (response) => {
            var dataset  = response.data;
            setFilterData(dataset);
            setLoading(false)
        })
        .catch((err) => {
            setLoading(false)
        });
    }

    const getFilterData = (datas)=>{
        console.log(datas,"dates")
        if(datas?.fromDate){
            setFromDate(datas?.fromDate)
        }

        if(datas?.toDate){
            setToDate(datas?.toDate)
        }
    }

    const sortTable = (fieldName)=>{
        if(sortBy == fieldName){
            var lclOrder = sortOrder == "DESC" ? "ASC":"DESC";
            setSortOrder(lclOrder)
            setSortBy(fieldName);
            fetchMainData(activePage,lclOrder)
        }else{
            setSortBy(fieldName);
            fetchMainData(activePage)
        }
       
    }



    return (
        <div className="container-fluid">
            <div className="row trxParams mt-5">
                <div className="col-md-3">
                    <div><b>Security Name:</b> {filterData?.security?.securityName ?? "-"}</div>
                    <div className="mt-1"><b>Security Ccy:</b> {filterData?.security?.currencyShortname ?? "-"}</div>
                    <div className="mt-1"><b>Asset Class:</b> {filterData?.security?.assetClass ?? "-"}</div>
                </div>
                <div className="col-md-3">
                    <div><b>ISIN:</b> {filterData?.security?.isin ?? "-"}</div>
                    <div className="mt-1"><b>Ticker:</b> {filterData?.security?.ticker ?? "-"}</div>
                </div>
                <div className="col-md-3">
                    <div><b>Underlying Security:</b> {filterData?.underlyingSecurity ?? "-"}</div>
                    <div className="mt-1"><b>Underlying Security Ccy:</b> {filterData?.underlyingSecurityCurrency ?? "-"}</div>
                </div>
            </div>
          <div className="card theme-colered no-border-radius mt-3">
                 <div className="card-body">
                     <Filter payload={state?.payload} filterData={filterData} getData={getFilterData} reloadData={fetchMainData}/>
                     <div className="col-md-12">
                     <Table class="mt-3">
                        <thead>
                            <tr>
                                <th colSpan="13" className="thHeader">Option Transactions</th>
                            </tr>
                            <tr>
                                <th rowspan="2" className="pointer" onClick={()=>sortTable("tradeDate")} data-name="tradeDate">Trade Date</th>
                                <th rowspan="2" className="pointer" onClick={()=>sortTable("date")} data-name="date">Value Date</th>
                                <th colspan="3" className="greenBg">Option Security</th>
                                <th colspan="8" className="orangeBg">Underlying Security</th>
                            </tr>
                            <tr>
                                
                                <th className="pointer" onClick={()=>sortTable("uiTransactionType")} data-name="uiTransactionType">Transaction Type</th>
                                <th className="pointer" onClick={()=>sortTable("units")} data-name="units">Quantity</th>
                                <th className="pointer" onClick={()=>sortTable("pricePerUnit")} data-name="pricePerUnit">Unit Price</th>
                                <th className="pointer" onClick={()=>sortTable("underlyingSecurityTransactionType")} data-name="underlyingSecurityTransactionType">Transaction Type</th>
                                <th className="pointer" onClick={()=>sortTable("grossAmount")} data-name="grossAmount">Gross Amount</th>
                                <th className="pointer" onClick={()=>sortTable("underlyingSecurityQuantity")} data-name="underlyingSecurityQuantity">Quantity</th>
                                <th className="pointer" onClick={()=>sortTable("strikePrice")} data-name="strikePrice">Strike Price</th>
                                <th className="pointer" onClick={()=>sortTable("amount")} data-name="amount">Net Amount</th>
                                <th className="pointer" onClick={()=>sortTable("uniqueId")} data-name="uniqueId">Transaction ID</th>
                                <th className="pointer" onClick={()=>sortTable("broker")} data-name="broker">Broker</th>
                                <th className="pointer" onClick={()=>sortTable("custodian")} data-name="custodian">Custodian</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                !Helpers.isEmpty(data) ? data.map((list,i)=>(
                                    <tr>
                                        <td>{Helpers.getDateInInputFormat(list?.tradeDate)}</td>
                                        <td>{Helpers.getDateInInputFormat(list?.date)}</td>
                                        <td>{list?.uiTransactionType}</td>
                                        <td className="text-right">{Helpers.formatNumberComma(list?.unit ?? 0 )}</td>
                                        <td className="text-right">{Helpers.formatNumberComma(list?.pricePerUnit ?? 0 )}</td>
                                        <td className="text-right">{list?.underlyingSecurityTransactionType}</td>
                                        <td className="text-right">{Helpers.formatNumberComma(list?.grossAmount ?? 0)}</td>
                                        <td className="text-right">{Helpers.formatNumberComma(list?.underlyingSecurityQuantity ?? 0)}</td>
                                        <td className="text-right">{Helpers.formatNumberComma(list?.strikePrice ?? 0)}</td>
                                        <td className="text-right">{Helpers.formatNumberComma(list?.amount ?? 0)}</td>
                                        <td>{list?.uniqueId}</td>
                                        <td>{list?.broker?.name}</td>
                                        <td>{list?.custodian?.name}</td>
                                    </tr>
                                ))
                                :
                                <tr>
                                    <td className="text-center" colSpan="999">No data found</td>
                                </tr>
                            }
                        </tbody>
                        </Table>
                    </div>
                    <MyPagination totalRecords={totalRecords} onChange={handlePageChange} activePage={activePage+1} />
                    <div className="col-md-12">
                             <button className="btn btn-back float-end" onClick={() => navigate(-1)}>
                                <i className="fas fa-reply"></i> Back
                            </button>
                    </div>
                 </div>
             </div>
    </div>
    )
}

export default Options
